import { createClient, } from "@kameleoon/react-sdk";
import { kameleoonEnvMapping } from "@/types/kameleoonEnvMapping";
/**
 * Factory for a KameleoonClient.
 */
export function makeKameleoonClient(siteCode, env) {
    return createClient({
        siteCode,
        configuration: {
            updateInterval: 60,
            environment: kameleoonEnvMapping[env],
        },
    });
}
